"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_virtualized_1 = require("react-virtualized");
var hooks_1 = require("../hooks");
var constants_1 = require("../../constants");
var DataGridCell_1 = require("../../DataGridCell");
var useStyles_1 = __importDefault(require("./useStyles"));
var DataGridRowRenderer_1 = require("../../DataGridRowRenderer");
var AutoSizer = react_virtualized_1.AutoSizer;
var Table = react_virtualized_1.Table;
var Column = react_virtualized_1.Column;
var DataGridMobileBody = function (props) {
    var data = props.data, rowHeight = props.rowHeight, onLastRow = props.onLastRow, rowRenderer = props.rowRenderer;
    var classes = (0, useStyles_1.default)();
    var cellMeasurerCache = (0, hooks_1.useCellMeasurerCache)(rowHeight);
    var rowGetter = (0, hooks_1.useRowGetter)(data, data.length, onLastRow).rowGetter;
    var mobileRowRenderer = (0, react_1.useMemo)(function () { return (0, DataGridRowRenderer_1.dataGridMobileRowRenderer)(rowRenderer); }, [rowRenderer]);
    return (react_1.default.createElement("div", { style: { height: '100%' } },
        react_1.default.createElement(AutoSizer, null, function (_a) {
            var width = _a.width, height = _a.height;
            return (react_1.default.createElement(Table, { width: width, height: height, rowCount: data.length, rowHeight: cellMeasurerCache.rowHeight, noRowsRenderer: function () { return react_1.default.createElement("span", null); }, disableHeader: true, headerHeight: 50, rowGetter: rowGetter, rowRenderer: mobileRowRenderer },
                react_1.default.createElement(Column, { dataKey: "data-mobile-row", className: classes.column, width: constants_1.DEFAULT_COLUMN_WIDTH, flexGrow: 1, cellRenderer: function (cellRendererProps) { return (react_1.default.createElement(DataGridCell_1.DataGridMobileCell, __assign({}, cellRendererProps, { cellMeasurerCache: cellMeasurerCache }))); } })));
        })));
};
exports.default = DataGridMobileBody;
